<template>
  <span :class="{'active':isActive}"  @click="clickItem(item)" >{{item.name || item}}</span>
</template>

<script>
export default {
  name: 'select-item',
  props: ["item","isActive","value"],
  methods: {
    clickItem(item){
      this.$emit("change",{
        ...item,
        index:this.value
      })
    }
  },
}
</script>